export default __webpack_public_path__ + "86eb882f912b422a697b6b7aaad870a9.png";